import axios from "axios";
import { authHeaderFile, authHeaderJson, authHeaderRecaptcha } from "./auth-header.service";
import { removeAuth } from "../common/Helpers";
import { WEB_CORE_URL } from "../configurations/paths.config";


const REFRESH_TOKEN_URL = `/apie/refreshToken`;
const AUTH_FREE_URLS = [
  REFRESH_TOKEN_URL,
  `/api/login`,
  `/api/do-login`,
  `/api/do-login-aad`,
  `/api/loginAAD`,
  `/api/2flogin`,
  `/api/account/validate-email-login`,
  `/api/account/validate-email-login-aad`,
  `/api/account/regenerate-code`,
  `/api/account/get-domains`,
  `/api/account/get-domains-fpw`,
  `/api/account/confirm-email`,
  `/api/resetpassword`,
];

let refreshPromise = null;

const isAuthFreeRequest = (config) => {
  const url = config?.url || "";
  return AUTH_FREE_URLS.some((publicUrl) => url.startsWith(publicUrl));
};

const refreshSession = async () => {
  if (!refreshPromise) {
    refreshPromise = axios
      .post(REFRESH_TOKEN_URL, null, { headers: authHeaderJson(), __skipRefresh: true })
      .finally(() => {
        refreshPromise = null;
      });
  }

  return refreshPromise;
};

const register = async (userObject) => {
  return await axios.post(`/api/account/register`, userObject, { headers: authHeaderFile() } );
};

const resendTwoFactor = async (username, password, domain, rememberme, loginMode, languaje, codeType = 2) => {
  const response = await axios.post(`/api/account/regenerate-code/${codeType}`, {
    username,
    password,
    domain,
    rememberme,
    loginMode,
    languaje,
    twoFactorCode: ""
  });
  
  return response.data;
};

const login = async (username, password, domain, rememberme, loginMode, languaje, recaptcha_token) => {
  const response = await axios.post(`/api/login`, 
  {
    username,
    password,
    domain,
    rememberme,
    loginMode,
    languaje,
    twoFactorCode: "",
    recaptcha_token: recaptcha_token
  }, { headers: authHeaderRecaptcha() });

  return response.data;
};

const loginAAD = async (username, password, domain, rememberme, loginMode, languaje, recaptcha_token, msal_token) => {
  console.log()
  const response = await axios.post(`/api/loginAAD`, 
  {
    username,
    password,
    domain,
    rememberme,
    loginMode,
    languaje,
    twoFactorCode: "",
    recaptcha_token: recaptcha_token,
    msalToken: msal_token
  }, { headers: authHeaderJson() });
  console.log(response.data)
  return response.data;
};

const loginTwoFactor = async (username, password, domain, rememberme, loginMode, languaje, twoFactorCode) => {
  const response = await axios.post(`/api/2flogin`, {
    username,
    password,
    domain,
    rememberme,
    loginMode,
    languaje,
    twoFactorCode
  });

  return response.data;
};

const validateEmailLogin = (email, type, recaptchaToken) => {
  return axios.request({ method: 'post', maxBodyLength: Infinity, url: `/api/account/validate-email-login`, headers: { 'accept': '*/*',  'Content-Type': 'application/json-patch+json' }, data : JSON.stringify({email: email, accountType: type, recaptchaToken: recaptchaToken}) })
};

const validateEmailLoginAAD = (email, type, recaptchaToken, msalToken) => {
  return axios.post(`/api/account/validate-email-login-aad`, { email, accountType: type, recaptchaToken, msalToken }, { headers: { accept: '*/*', 'Content-Type': 'application/json' }, maxBodyLength: Infinity });
};

const logout = async (urlRedirect, flag, userName) => {
  try {
    await axios.post(`/api/account/logout?userName=${encodeURIComponent(userName || "")}`, null, { headers: authHeaderJson() });
  } catch (error) {
    // Aunque falle el logout en API, se limpia la sesión local/cookies del navegador.
  } finally {
    removeAuth();
    window.location.href = `${WEB_CORE_URL}/logout?stats=success`;
  }
};

const getDomains = (email, recaptchaToken = "") => {
  return axios.post(`/api/account/get-domains?email=${encodeURIComponent(email)}&recaptchaToken=${encodeURIComponent(recaptchaToken)}`, null);
};

const getDomainsFPw = () => {
  return axios.post(`/api/account/get-domains-fpw`, null);
};

const forgotPassword = async (domain, userName, email, confirmationEmail, languaje) => {
  const data = JSON.stringify({domain: domain, userName: userName, email: email, confirmEmail: confirmationEmail, languaje: languaje});
  //const config = { method: 'post', url: `/api/account/forgot-pass`,headers: authHeaderJson(), data : data };
  const config = { method: 'post', url: `/api/account/2f-set-forgot-pwd`, headers: authHeaderJson(), data: data };

  return await axios(config);
};

const confirmEmail = async (token, email, languaje) => {
  const data = JSON.stringify({token: token, email: email, languaje: languaje});
  const config = { method: 'post', url: `/api/account/confirm-email`,headers: authHeaderJson(), data : data };
  
  return await axios(config);
};

const resetPassword = async (objResetPasswordModel) => {
  const data = JSON.stringify(objResetPasswordModel);
  //const config = { method: 'post', url: `/api/account/reset-pass`,headers: authHeaderJson(), data : data };
  //return await axios(config);

  const response = await axios.post(`/api/resetpassword`, objResetPasswordModel, { headers: authHeaderRecaptcha() });
  return response;
};

const changePassword = async (userId, password, newPassword) => {
  const data = JSON.stringify({userId: userId, password: password, newPassword: newPassword});
  const config = { method: 'post', url: `/api/account/change-pass`,headers: authHeaderJson(), data : data };
  
  return await axios(config);
};

const validateExternalHash = async (externalObject) => {
  const config = { method: 'post', url: `/api/user/validate-link-external-account`, headers: authHeaderJson(), data : externalObject };
  return await axios(config);
};

const validateExternalLogin = async (externalObject) => {
  const data = JSON.stringify(externalObject);
  
  const config = {
    method: 'post',
    url: `/api/account/external-login`,
    headers: { 
      'Content-Type': 'application/json'
    },
    data : data
  };
  
  return axios(config)
};

const generateSkh = async (userName) => {
  
  const config = { method: 'post', url: `/api/account/generate-skh?userName=${encodeURIComponent(userName)}`, headers: authHeaderJson(), data : null };
  return await axios(config);
};

const sendAADInvitation = async (userName, clientId) => {
  const config = { method: 'post', url: `/api/invitations/aad-invite`, headers: authHeaderJson(), data : {userName, clientId} };
  return await axios(config);
};


const revokeUserSessions = async (userName) => {
  const config = { method: 'post', url: `/api/token/revoke/${userName}`, headers: authHeaderJson(), data : userName };
  return await axios(config);
};

export default {
  register,
  login,
  loginAAD,
  refreshSession,
  loginTwoFactor,
  resendTwoFactor,
  validateEmailLogin,
  validateEmailLoginAAD,
  logout,
  getDomains,
  getDomainsFPw,
  forgotPassword,
  resetPassword,
  confirmEmail,
  changePassword,
  validateExternalHash,
  validateExternalLogin,
  generateSkh,
  sendAADInvitation,
  revokeUserSessions
};